import { activityStatuses } from "features/activity/activityConsts";
import { sum } from "lodash";
import FormatService from "services/formatService";
import GraphHeader from "../GraphHeader/GraphHeader";
import { workorderDashboardPageStyles } from "../WorkorderDashboardPageStyles";
import { Tooltip as MuiTooltip } from '@material-ui/core';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';

const WorkorderCostTotal = ({ workorders }) => {
    const classes = workorderDashboardPageStyles();

    const completed = workorders?.filter(a => a.activityStatus == activityStatuses.Completed) ?? [];
    const total = sum(completed?.map(a => a.revenue) ?? []);

    return (
        <div style={{ height: 350 }}>
            <GraphHeader 
                title={'Total Cost'} 
                rightContent={
                    <MuiTooltip title={"This value is the charge for all completed activities in the selected month"}>
                        <InfoOutlinedIcon />
                    </MuiTooltip>
                }
            />
            <div className={classes.totalCost}>
                {FormatService.formatCurrency(total)}
            </div>
        </div>
    )
}

export default WorkorderCostTotal;
